import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components/ui';
import iconList from 'fonts/icons/unicodesMap.json';
import classNames from 'classnames';
import './list.scss';
import SimpleBar from 'simplebar-react';

const IconList = ({ onIconClick, selectedIcon }) => {
  const [selected, setSelected] = useState(selectedIcon);
  const list = Object.keys(iconList);

  const onSelectIcon = (iconToSelect) => {
    setSelected(iconToSelect);
    if (onIconClick) {
      onIconClick(iconToSelect);
    }
  };

  return (
    <SimpleBar style={{ width: '100%', maxHeight: '350px' }}>
      <div className="icon-list-grid">
        {list.map((item) => {
          const iconName = item.replace('icon-', '');
          return (
            <button
              key={item}
              type="button"
              className={classNames('icon-list-item', { active: selected === iconName })}
              onClick={() => onSelectIcon(iconName)}
            >
              <Icon name={iconName} />
            </button>
          );
        })}
      </div>
    </SimpleBar>
  );
};

IconList.defaultProps = {
  onIconClick: null,
  selectedIcon: null,
};

IconList.propTypes = {
  onIconClick: PropTypes.func,
  selectedIcon: PropTypes.string,
};

export default IconList;
